<template>
    <span
        v-if="scrolled === true"
        v-on:click="scrollToTop()"
        class="scrollToTop"
    >
        <svg
            class="scrollToTopIcon"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 640 640"
        >
            <!--!Font Awesome Pro v7.3.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2026 Fonticons, Inc.-->
            <path opacity=".4" fill="#39b3d7" d="M64 320C64 461.4 178.6 576 320 576C461.4 576 576 461.4 576 320C576 178.6 461.4 64 320 64C178.6 64 64 178.6 64 320zM223 279L303 199C312.4 189.6 327.6 189.6 336.9 199L416.9 279C426.3 288.4 426.3 303.6 416.9 312.9C407.5 322.2 392.3 322.3 383 312.9L344 273.9L344 424C344 437.3 333.3 448 320 448C306.7 448 296 437.3 296 424L296 273.9L257 312.9C247.6 322.3 232.4 322.3 223.1 312.9C213.8 303.5 213.7 288.3 223.1 279z"/>
            <path fill="#39b3d7" d="M303 199C312.4 189.6 327.6 189.6 336.9 199L416.9 279C426.3 288.4 426.3 303.6 416.9 312.9C407.5 322.2 392.3 322.3 383 312.9L344 273.9L344 424C344 437.3 333.3 448 320 448C306.7 448 296 437.3 296 424L296 273.9L257 312.9C247.6 322.3 232.4 322.3 223.1 312.9C213.8 303.5 213.7 288.3 223.1 279L303.1 199z"/>
        </svg>
    </span>
</template>

<script>
export default {
    name: 'scroll-to-top',
    data () {
        return {
            scrolled: false
        }
    },
    methods: {
        handleScroll () {
            this.scrolled = window.scrollY > 0
        },
        scrollToTop () {
            var element = document.getElementById("app")
            var top = element.offsetTop
            window.scrollTo(0, top)
        }
    },
    beforeMount () {
        window.addEventListener('scroll', this.handleScroll)
    },
    beforeUnmount () {
        window.removeEventListener('scroll', this.handleScroll)
    }
}
</script>

<style scoped>
    .scrollToTop {
        text-align:center;
        font-weight: bold;
        text-decoration: none;
        position:fixed;
        bottom:40px;
        right:40px;
        text-align: center;
        font-size: 68px;
        z-index: 999;
    }
    .scrollToTopIcon {
        width: 1em;
        height: 1em;
    }
</style>
